<template>
  <div class="table-search-container">
	  
    <a-input-search
      placeholder="请输入搜索内容"
      style="width:225px;margin-right:20px;"
      @search="value => $emit('onSearch', value)"
    />
    <a-select placeholder="请选择合作企业" v-model="companyId"  style="width: 225px; margin-right:20px;"   @change="value => $emit('onChangecompany', value)">
	    <a-select-option v-for="item in companyData" :key="item.id" :value="item.id">
	      {{ item.companyInfo.qichacha_name }}
	    </a-select-option>
	  </a-select>
    <a-button
	    type="primary"
	    shape="round"
	    icon="download"
		style="margin-right:20px;margin-left: 0;"
	    @click="$emit('onExport')"
	  >
	    导出任务进度
	  </a-button>
    <a-button
      type="primary"
      shape="round"
      icon="plus"
      @click="$emit('editAndAdd')"
      style="margin-left:0px;"
      v-if="addbtnIsShow"
      >{{ addText }}</a-button
    >
  </div>
</template>
<script>
export default {
  props: ['selectData', 'addText', 'addbtnIsShow'],
  data() {
    return {companyData: [],
		companyId:'',};
  },
  mounted() {
   
     this.getCompanyList();
   
  },
  methods: {
    filterOption(input, option) {
      // return (
      //   option.componentOptions.children[0].text
      //     .toLowerCase()
      //     .indexOf(input.toLowerCase()) >= 0
      // );
    },
	// 获取合作企业
	async getCompanyList() {
	  let result = await this.$http.post('/Company/getCooperationCompanyList');
	  if (result.data.status === 1) {
	   this.companyData = result.data.data.data_list;
	   this.companyId=this.companyData[0].id
	  }
	},
  },
};
</script>
<style lang="scss">
.table-search-container {
  height: 70px;
  line-height: 70px;
  .ant-input {
    border-radius: 15px;
    height: 30px;
  }
  .ant-select-selection {
    border-radius: 15px;
  }
  .ant-btn-round {
    font-size: 12px;
    height: 30px;
    padding: 0 17px;
    border-radius: 15px;
  }
}
</style>
